import type { FormatOptions } from "date-fns/format";
import { format } from "date-fns/format";
import { enUS } from "date-fns/locale/en-US";

import type { Locale } from "../types/locale.types";

export const getDateLocale = async (locale: Locale) => {
  switch (locale) {
    case "de":
      return (await import("date-fns/locale/de")).de;
    case "es":
      return (await import("date-fns/locale/es")).es;
    case "fr":
      return (await import("date-fns/locale/fr")).fr;
    case "it":
      return (await import("date-fns/locale/it")).it;
    case "pl":
      return (await import("date-fns/locale/pl")).pl;
    case "pt":
      return (await import("date-fns/locale/pt-BR")).ptBR;
    case "en":
    case "en-PH":
    default:
      return enUS;
  }
};

export const getDateFormatter = async (locale: Locale) => {
  const dateFnsLocale = await getDateLocale(locale);

  return (dt: Date, formatStr: string, options?: FormatOptions) =>
    format(dt, formatStr, { ...options, locale: dateFnsLocale });
};
